import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import areaReducer from './slices/areaSlice';
import stateReducer from './slices/stateSlice';
import districtReducer from './slices/districtSlice';
import cityReducer from './slices/citySlice';
import adminDashboardReducer from './slices/adminDashboardSlice';
import representativeReducer from './slices/representativeSlice';
import announcementReducer from './slices/announcementSlice';
import issueReducer from './slices/issueSlice';
import communityIssueReducer from './slices/communityIssueSlice';
import feedbackReducer from './slices/feedbackSlice';
import contentModerationReducer from './slices/contentModerationSlice';
import volunteerAssignmentReducer from './slices/volunteerAssignmentSlice';
import professionalReducer from './slices/professionalSlice';
import analyticsReducer from './slices/analyticsSlice';
import messageReducer from './slices/messageSlice';
import servicesReducer from './slices/serviceSlice';
import followReducer from './slices/followSlice';
import ratingReducer from './slices/ratingSlice';
import postReducer from './slices/postSlice';
import complaintReducer from './slices/complaintSlice';
import ministryReducer from './slices/ministrySlice';
import politicalPartyReducer from './slices/politicalPartySlice';
import publicOfficialsReducer from './slices/publicOfficialsSlice';
import constituenciesTypeReducer from './slices/constituenciesTypeSlice';
import constituenciesReducer from './slices/constituenciesSlice';
import workAssignmentReducer from './slices/workAssignmentSlice';
import categoryReducer from './slices/categorySlice';
import auditTrailReducer from './slices/auditTrailSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    areas: areaReducer,
    states: stateReducer,
    districts: districtReducer,
    cities: cityReducer,
    adminDashboard: adminDashboardReducer,
    representative: representativeReducer,
    announcement: announcementReducer,
    issues: issueReducer,
    communityIssues: communityIssueReducer,
    feedbacks: feedbackReducer,
    contentModeration: contentModerationReducer,
    volunteerAssignment: volunteerAssignmentReducer,
    professional: professionalReducer,
    analytics: analyticsReducer,
    messages: messageReducer,
    services: servicesReducer,
    follow: followReducer,
    rating: ratingReducer,
    post: postReducer,
    complaint: complaintReducer,
    ministries: ministryReducer,
    politicalParty: politicalPartyReducer,
    publicOfficials: publicOfficialsReducer,
    constituenciesType: constituenciesTypeReducer,
    constituencies: constituenciesReducer,
    workAssignment: workAssignmentReducer,
    categories: categoryReducer,
    auditTrail: auditTrailReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
